let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let ProOnly = require("../../../../widgets/ProOnly");
let FormMixin = require("react-loose-forms");
let ApplyListModal = require("./ApplyListModal");
let ActionListTable = require("./ActionListTable");
let AuthedUserSession = require("../../../../../utils/AuthedUserSession");
let NewActionItemForm = require("./NewActionItemForm");
let normalizeUsername = require("../../../../../utils/normalizeUsername");
let getActionListDropDownOptions = require("../../../../../utils/getActionListDropDownOptions");

let ActionListSelector = dd.createClass({
  mixins: [FormMixin],
  getInitialValues(props) {
    let { event } = props;
    let todolist = _.first(event.todolistids) || null; //this should degrade nicely if there are no todolistids
    return { todolist: todolist };
  },
  buildSchema() {
    let { event, Displaylists } = this.props;
    return {
      todolist: {
        type: "select",
        placeholder: "-- select actionlist --",
        dont_sort_options: false,
        options: getActionListDropDownOptions(
          Displaylists,
          _.get(event, "sids", []),
          _.get(event, "companyID", 0)
        ),
      },
    };
  },
  __onClose: esUtils.wrapPreventDefault(function () {
    this.Form_reset();
  }),
  render() {
    let { event, Displaylists } = this.props;
    let data = this.state.data || {};
    let fields = this.Form_buildSchema();
    let changes_made = this.Form_areChangesMade();

    let error =
      esUtils.isBlank(data.todolist) && changes_made
        ? "Please select a an actionlist"
        : null;

    return dd.div(
      { style: { margin: "15px 0" } },
      dd.div(
        { className: "row" },
        dd.div(
          { className: "col-sm-8" },
          this.Form_buildInput(fields["todolist"]),
          error ? dd.span({ className: "text-danger" }, error) : null
        )
      ),
      changes_made && !error
        ? ApplyListModal({
            event,
            Displaylists,
            list_id: data.todolist,
            onClose: this.__onClose,
          })
        : null
    );
  },
});

module.exports = dd.createClass({
  __addItem(data) {
    let event = _.cloneDeep(this.props.event);
    if (!_.isArray(event.EventTodo)) {
      event.EventTodo = [];
    }
    event.EventTodo.push({
      id: 0,
      eid: event.eid,
      description: data.description,
      statusdate: data.statusdate,
      statusdate_ISO8601: _.isDate(data.statusdate)
        ? data.statusdate.toISOString()
        : null,
      assignedto: normalizeUsername(data.assignedto),
    });
    radio("save_Event").broadcast(event);
  },
  __saveActionLists(data) {
    let event = _.cloneDeep(this.props.event);
    event.EventTodo = _.map(event.EventTodo, function (todo) {
      let id = todo.id;
      todo.status = data[id + "_status"] ? 1 : 0;
      todo.description = data[id + "_description"] + "";
      todo.email_recipient_group = data[id + "_email_recipient_group"] + "";
      todo.statusdate = _.isDate(data[id + "_statusdate"])
        ? data[id + "_statusdate"]
        : null;
      todo.statusdate_ISO8601 = _.isDate(data[id + "_statusdate"])
        ? data[id + "_statusdate"].toISOString()
        : null;
      todo.assignedto = normalizeUsername(data[id + "_assignedto"]);
      return todo;
    });
    radio("save_Event").broadcast(event);
  },
  __deleteItem(item_id) {
    let event = _.cloneDeep(this.props.event);
    event.EventTodo = _.filter(event.EventTodo, function (todo) {
      return item_id != todo.id;
    });
    radio("save_Event").broadcast(event);
  },
  render() {
    let { event, Displaylists } = this.props;
    let can_I_manage =
      AuthedUserSession.doIHaveAccess.admin.any(event.sids) &&
      !AuthedUserSession.is_st; //hidden for ST

    let read_only = !(
      AuthedUserSession.doIHaveAccess.full.any(event.sids) ||
      AuthedUserSession.doIHaveAccess.admin.any(event.sids)
    );

    return dd.div(
      { className: "ActionList" },
      dd.div(
        null,
        dd.span(
          { className: "pull-right", style: { marginTop: -3 } },
          can_I_manage
            ? dd.a(
                {
                  href:
                    AuthedUserSession.privatelabel_code === "cs" ?
                      "/myevents/#/account_settings/action_list" :
                    "/dashboard/token-callback?token=" +
                    _.get(AuthedUserSession, ["balboa", "estoken"], "") +
                    "&redir=" +
                    _.first(event.sids) +
                    "/actionlist-settings",
                  target: "_blank",
                  className: "printlink",
                },

                dd.i({ className: "fa fa-gear" }),
                " customize master list"
              )
            : null
        ),
        dd.h2({ style: { marginBottom: read_only ? null : 0 } }, "Action List")
      ),
      read_only
        ? null
        : dd.div(
            null, //wrapping ProOnly in a div to hack around the funky padding issue
            ProOnly(
              { sids: event.sids },
              ActionListSelector({ event, Displaylists })
            )
          ),
      dd.div(
        { className: "panel panel-default" },
        dd.div(
          { className: "panel-body" },
          ActionListTable({
            event,
            Displaylists,
            read_only,
            onSubmit: this.__saveActionLists,
            deleteItem: this.__deleteItem,
          })
        )
      ),
      read_only
        ? null
        : dd.div(
            null, //wrapping ProOnly in a div to hack around the funky padding issue
            ProOnly(
              { sids: event.sids },
              dd.div(
                { style: { marginBottom: 30 } },
                NewActionItemForm({
                  event,
                  Displaylists,
                  onSubmit: this.__addItem,
                })
              )
            )
          )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/index.js